/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './advertiser-invite-editor-modal.component.html';
import {AdvertiserResource} from '../../components/api/resources/resource/advertiser.resource';

@Component({
  standalone: false,
  selector: 'adn-advertiser-invite-editor-modal',
  template
})
export class AdvertiserInviteEditorModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  advertiserId: string;
  defaultSubject: string;

  inviteSending = false;
  inviteSent = false;
  inviteEmail = '';
  inviteName = '';
  inviteSubject = '';
  inviteError = '';

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(AdvertiserResource) private readonly Advertiser: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.inviteSubject = this.defaultSubject || '';
  }

  sendInvite(): void {
    this.inviteSending = true;
    this.inviteError = '';
    this.cdr.markForCheck();
    const subject = this.inviteSubject === this.defaultSubject ? '' : this.inviteSubject;
    this.Advertiser.emailInvite({
      id: this.advertiserId,
      name: this.inviteName,
      email: this.inviteEmail,
      subject
    }).$promise.then(() => {
      this.inviteSending = false;
      this.inviteSent = true;
      this.cdr.markForCheck();
    }, (response: any) => {
      this.inviteSending = false;
      this.inviteError = response.data.text;
      this.cdr.markForCheck();
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
